import { useAppSelector } from "app/redux/hooks"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import globalMU from "globalMU"
import pMemoize from "p-memoize"
import React, { useEffect, useState } from "react"
import microuniversoApi from "../../api/microuniversoApi"
import { ICampanhaDesconto } from "../../types/CupomDesconto/ICampanhaDesconto"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { CampanhasDeDescontosDisponiveis } from "./CampanhasDeDescontosDisponiveis"
import { DetalhamentoCampanhaDeDescontoContainer } from "./detalhamento-campanha-desconto-disponivel/DetalhamentoCampanhaDeDescontoContainer"

export type CampanhasDeDescontosDisponiveisContainerProps = {
    clienteMais?: boolean;
    onVoltar: () => void;
}

declare const window: any

export const CampanhasDeDescontosDisponiveisContainer = (props: CampanhasDeDescontosDisponiveisContainerProps) => {

    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const [carregouCampanhasSelecionadas, setCarregouCampanhasSelecionadas] = useState<boolean>(false)
    const [campanhas, setCampanhas] = useState<ICampanhaDesconto[]>([]);
    const [campanhasSelecionadas, setCampanhasSelecionadas] = useState<ICampanhaDesconto[]>([]);
    const [podeEntrarNaTela, setPodeEntrarNaTela] = useState<boolean>(null)

    const onCampanhasSelecionadas = (campanhasSelecionadas: ICampanhaDesconto[]) => {
        setCampanhasSelecionadas(campanhasSelecionadas)
    }

    const confirmarCampanhasSelecionadas = async () => {

        store.dispatch(sobrescreverInformacoesAction({
            CuponsDescontoSelecionados: campanhasSelecionadas
        }))
        await microuniversoApi.CupomDesconto.AdicionarCuponsOrcamento(
            orcamento.IdentificadorOrcamento,
            campanhasSelecionadas.map(c => c.Id),
            orcamento.ItensOrcamento?.map(i => i.Codigo))
            .then((result) => {
                globalMU.showSuccessMessage('Cupons de desconto selecionados com sucesso!');
            })
        const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(orcamento.IdentificadorOrcamento)
        window.orcamentoController.model.atualizar(itensTotaisOrcamento)


    }

    const onValidarAcessoCuponsDeDesconto = async () => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Orcamento.ValidarAcessoCuponsDeDesconto(orcamento.IdentificadorOrcamento)
            /* 
            resposta && props.onVoltar()
            */
            // ValidarAcessoCuponsDeDesconto é Promise<boolean> (ver OrcamentoApi.ts:192), então o
            // ramo `typeof resposta === 'object'` que existia aqui nunca executava em runtime — o
            // TypeScript 5 passou a acusá-lo (TS18047, 'resposta' is possibly 'null'). Removido
            // sem mudar comportamento: false volta para a tela anterior, true libera a entrada.
            if (resposta === false) {
                props.onVoltar();
            } else {
                setPodeEntrarNaTela(true)
            }
        } catch (e) {
            setPodeEntrarNaTela(false)
            tratamentoErroPadrao(e);
            props.onVoltar()
            
        } finally {
            globalMU.unblockUI();
        }
    }

    const abrirDetalhamento = (idCampanha: number) => {
        renderizarComponentReact(<DetalhamentoCampanhaDeDescontoContainer idCampanha={idCampanha} idCampanhas={campanhas?.map(c => c.Id)} onVoltarCliente={props.onVoltar} />, "conteudo-pagina", true)
    }

    const [buscarCampanhasDescontoMemoize] = useState<Function>(() => pMemoize(async (): Promise<ICampanhaDesconto[]> => {
        return await microuniversoApi.CupomDesconto.BuscarTodasCampanhasDescontosValidas(orcamento.CodigoCliente, orcamento.CodigoFilialOrcamento, orcamento.Cliente.CpfCnpj, orcamento.Cliente.ClienteMais)
    }))

    const atualizarCampanhasDesconto = async () => {
        setCampanhas(await buscarCampanhasDescontoMemoize(orcamento.CodigoCliente))
    }

    const atualizarSelecionadas = async () => {
        setCampanhasSelecionadas(await microuniversoApi.CupomDesconto.ObterCuponsUtilizadosOrcamento(orcamento.IdentificadorOrcamento))
        setCarregouCampanhasSelecionadas(true)
    }

    useEffect(() => {
        onValidarAcessoCuponsDeDesconto()
    }, [])

    useEffect(() => {
        if (podeEntrarNaTela !== null && podeEntrarNaTela === true) 
        {
            atualizarCampanhasDesconto()
            atualizarSelecionadas()
        }
    }, [podeEntrarNaTela])


    return  <>{podeEntrarNaTela &&
    <>
        <Breadcrumb2Container
            exibirBotaoLimpar={false}
            id="CampanhasDeDescontosDisponiveisContainer"
            exibirBotaoVoltar={true}
            passos={["Cadastro Cliente", "Campanha de Descontos Disponíveis"]}
            onBotaoVoltarClicado={() => {
                props.onVoltar()
            }}
            onPassoSelecionado={passo => {
                if (passo == "Cadastro Cliente") {
                    props.onVoltar()
                }
            }} />
        {
            campanhas.length > 0 && carregouCampanhasSelecionadas &&
            <CampanhasDeDescontosDisponiveis campanhas={campanhas} campanhasSelecionadas={campanhasSelecionadas} onCampanhaSelecionada={onCampanhasSelecionadas} onAbrirDetalhamento={abrirDetalhamento} onFecharComponente={props.onVoltar} onConfirmarCampanhasSelecionadas={confirmarCampanhasSelecionadas} />
        }
    </>
}
    </>
}
